<template>
  <v-dialog
    v-model="show"
    max-width="600"
    persistent
  >
    <v-card flat>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div class="mb-4">
          <h4 class="grey--text darken-4 mb-0">
            Status de escoamento por períodos:
          </h4>
        </div>
        <div
          v-for="(period, index) in periods"
          :key="index"
          class="period-item"
        >
          <div class="d-flex align-center">
            <div
              :class="getPeriodIconWrapperClass(period.status)"
              class="period-icon-wrapper mr-3"
            >
              <v-icon
                :class="getPeriodIconClass(period.status)"
                size="16"
              >
                {{ getPeriodIcon(period.status) }}
              </v-icon>
            </div>
            <div class="flex-grow-1">
              <div class="period-date font-weight-bold">
                {{ formatPeriodDate(period.startDate) }} à {{ formatPeriodDate(period.endDate) }}
              </div>
              <div
                v-if="period.status === 'confirmed'"
                class="period-status"
              >
                Confirmado: {{ formatDateTime(period.confirmedDate) }}
              </div>
              <div
                v-else
                class="period-status"
              >
                Pendente
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelloutPeriodsModal',
  data: () => ({
    show: false,
    title: '',
    periods: []
  }),
  methods: {
    open({ periods }) {
      const confirmedCount = periods.filter((p) => p.status === 'confirmed').length
      const total = periods.length
      const subtitle = total > 0 ? ` - Confirmado ${confirmedCount} de ${total}` : ''
      this.title = `Escoamento por período${subtitle}`
      this.periods = periods
      this.show = true
    },
    close() {
      this.show = false
      this.periods = []
      this.title = ''
    },
    getPeriodIcon(status) {
      return status === 'confirmed' ? 'check_circle' : 'schedule'
    },
    getPeriodIconClass(status) {
      return status === 'confirmed' ? 'icon-approved' : 'grey--text darken-1'
    },
    getPeriodIconWrapperClass(status) {
      return status === 'confirmed' ? 'icon-wrapper-approved' : 'icon-wrapper-pending'
    },
    formatPeriodDate(date) {
      if (!date) return '-'
      return this.$date(date)
    },
    formatDateTime(date) {
      if (!date) return '-'
      return this.$dateTime(date)
    }
  }
}
</script>

<style lang="stylus" scoped>
.period-item {
  padding: 0;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.period-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}

.icon-wrapper-approved {
  background-color: #C5FFDE;
}

.icon-approved {
  color: #006B38 !important;
}

.icon-wrapper-pending {
  background-color: #f5f5f5;
}

.period-date {
  font-size: 14px;
  line-height: 1.5;
  font-weight: 700;
  color: #001648;
}

.period-status {
  font-size: 12px;
  line-height: 1.5;
  color: #001648;
}
</style>

